module.exports = __webpack_public_path__ + "7c7e47d815e649b393fd3a78b97d12e5.png";